// extracted by mini-css-extract-plugin
module.exports = {"s1s6bhgg":"s1s6bhgg"};